import { useSubscribe } from "@/src/lib/actions";
import { useState } from "react";

export function usePageSize() {
  const [pageSize, setPageSize] = useState(10);

  useSubscribe<number>("ych:page-size", setPageSize);

  return pageSize;
}

export function useSearch() {
  const [search, setSearch] = useState("");

  useSubscribe<string>("ych:search", setSearch);

  return search;
}

export function useSorting() {
  const [sorting, setSorting] = useState("DESC");

  useSubscribe<string>("ych:sorting", setSorting);

  return sorting;
}

export function useDisable() {
  const [disable, setDisable] = useState(false)

  useSubscribe<boolean>("offer:disable-next", setDisable);

  return disable
}